import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import {
  MessageSummary,
  MessageType,
} from 'src/app/shared/enum/message-type.enum';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  public showSuccess(message: string): void {
    this.showToast(MessageType.SUCCESS, MessageSummary.SUCCESS, message);
  }

  public showInfo(message: string): void {
    this.showToast(MessageType.INFO, MessageSummary.INFO, message);
  }

  public showWarn(message: string): void {
    this.showToast(MessageType.WARN, MessageSummary.WARN, message);
  }

  public showError(message: string): void {
    this.showToast(MessageType.ERROR, MessageSummary.ERROR, message, 10000);
  }

  private showToast(
    severity: MessageType,
    summary: MessageSummary,
    detail: string,
    life: number = 5000,
  ): void {
    this.messageService.add({
      severity,
      summary,
      detail,
      life,
    });
  }
}
